// extracted by mini-css-extract-plugin
export default {"container":"n1-z","heading":"o1-z","links":"p1-z","copy":"q1-z","subCopy":"r1-z","linksLeft":"s1-z","linksCenter":"t1-z","linksRight":"u1-z","link":"v1-z","onlyLink":"w1-z"};